import Collection from "../singleton/collection";

export default {

    initByList: Collection.initByList.bind(Collection),

    initByEntity: Collection.initByEntity.bind(Collection),

    initByRelation: Collection.initByRelation.bind(Collection),

    setView: Collection.setView.bind(Collection),

    setFilters: Collection.setFilters.bind(Collection),

    toggleFieldSort: Collection.toggleFieldSort.bind(Collection),

    setFieldsOrder: Collection.setFieldsOrder.bind(Collection),

    setFieldWidth: Collection.setFieldWidth.bind(Collection),

    toggleFieldHidden: Collection.toggleFieldHidden.bind(Collection),

    toggleFieldReadonly: Collection.toggleFieldReadonly.bind(Collection),

    toggleLocked: Collection.toggleLocked.bind(Collection),

    setTextFilter: Collection.setTextFilter.bind(Collection),

    setFeedback: Collection.setFeedback.bind(Collection),

    isLinkedActive: Collection.isLinkedActive.bind(Collection),

    getLinkedOptions: Collection.getLinkedOptions.bind(Collection),

    getSimilarValues: Collection.getSimilarValues.bind(Collection),

    clear: Collection.clear.bind(Collection),

    Documents: {

        create: Collection.documentCreate.bind(Collection),

        update: Collection.documentUpdate.bind(Collection),

        delete: Collection.documentDelete.bind(Collection),

        bulkUpdate: Collection.documentBulkUpdate.bind(Collection),

        getDefaultValue: Collection.getDefaultValue.bind(Collection)

    }

}